import React, { useMemo } from 'react';
import Head from 'next/head';
import favicon from 'public/images/favicon.ico';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

const SecondaryPageLayout: React.FC = props => {
  const { children } = props;
  const router = useRouter();
  const { t } = useTranslation('common');

  const lang = ['ru'];

  const ogUrl = useMemo<string>(() => {
    if (process.browser) {
      return window.location.href;
    }

    return router.asPath;
  }, []);

  const ogImage = useMemo(() => {
    return `/og/open_graph_${router.locale}.png`;
  }, [router.locale]);

  return (
    <>
      <Head>
        <link rel='shortcut icon' href={favicon} type='image/x-icon' />
        <meta content='website' property='og:type' />
        <meta content={ogImage} property='og:image' />
        <meta content={ogUrl} property='og:url' />

        <link
          rel='apple-touch-icon'
          sizes='180x180'
          href='/images/apple-touch-icon.png'
        />
        <link
          rel='icon'
          type='image/png'
          sizes='32x32'
          href='/images/favicon-32x32.png'
        />
        <link
          rel='icon'
          type='image/png'
          sizes='16x16'
          href='/images/favicon-16x16.png'
        />
        <link
          rel='mask-icon'
          href='/images/safari-pinned-tab.svg'
          color='#5bbad5'
        />
        <meta name='theme-color' content='#050505' />

        {lang.map(value => (
          <link
            key={value}
            rel='alternate'
            hrefLang={value}
            href={`${process.env.NEXT_PUBLIC_API_HOST}/${
              value + router.pathname
            }`}
          />
        ))}
        <link
          rel='alternate'
          hrefLang='x-default'
          href={`${process.env.NEXT_PUBLIC_API_HOST + router.pathname}`}
        />
      </Head>
      {children}
    </>
  );
};

export default SecondaryPageLayout;
